module.exports = __webpack_public_path__ + "static/img/icon_mrtx_nv@2x.600106bf.png";